import { CheckCircle2, CircleDot } from 'lucide-react';
import type { RepairPlanItem } from '../../engine/core/types';

export function RepairPlan({ plan }: { plan: RepairPlanItem[] }): React.JSX.Element {
  return (
    <section className="analysis-panel repair-plan" aria-labelledby="repair-plan-title">
      <div className="panel-heading"><h2 id="repair-plan-title">Recommended Repair Plan</h2></div>
      {plan.length ? (
        <ol>
          {plan.map((item) => (
            <li key={item.rule.id}>
              <span>{item.order}</span>
              <div><strong>{item.title}</strong><p>{item.detail}</p><code>{item.rule.id} {item.rule.version}</code></div>
            </li>
          ))}
          <li className="repair-plan__validation"><CheckCircle2 /><div><strong>Final validation</strong><p>Reopen the rebuilt package, repeat analysis, and compare preserved parts.</p></div></li>
        </ol>
      ) : (
        <div className="panel-empty"><CircleDot /><strong>No implemented file change is recommended</strong><span>Inspect or extract content without modifying the source.</span></div>
      )}
    </section>
  );
}
